module.exports = __webpack_public_path__ + "static/media/energia.91060fdd.mp4";